export default [
    {
        path: window.pathApp + '/login-externo',
        name: 'login.externo',
        component: () => import('@/components/LoginExterno'),
        meta: {
            login: false,
            avisoCarrinho: false,
            title: "Processando Login Externo",
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/routes/login_externo.js